import { useEffect, useState } from "react";

const navLinks = [
  { href: "#home", label: "首页" },
  { href: "#ips", label: "热门IP" },
  { href: "#featured", label: "精选作品" },
  { href: "#latest", label: "最新更新" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/60 bg-background-950/90 shadow-none backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-accent-600 text-lg text-background-50">
            <i className="ri-ancient-pavilion-line"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">
            同人<span className="text-primary-400">漫研</span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-600 transition-colors hover:bg-background-800/60 hover:text-foreground-950"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            投稿入驻
          </a>
          <button
            type="button"
            aria-label="切换菜单"
            onClick={() => setOpen(!open)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-200 md:hidden"
          >
            <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/60 bg-background-950/95 backdrop-blur md:hidden">
          <ul className="mx-auto flex w-full max-w-7xl flex-col px-4 py-3">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-800/60 hover:text-foreground-950"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mt-2">
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="block rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-bold text-background-50"
              >
                投稿入驻
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}